import enBoard from './en';
import ruBoard from './ru';

export default {
  en: {
    ...enBoard,
  },
  ru: {
    ...ruBoard,
  },
};
